import React, { useEffect, useState } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { Markup } from 'interweave';
import { useHistory } from 'react-router-dom';
import FAQFirstIn from '../components/walkthrough/individualPage/FAQFirstIn';
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import { ChevronRight } from '../components/icons';
import { useLogPageVisit } from '../utils/logPageVisit';

const questionsAndAnswers = [
  {
    question: `Why is my last check held/ When will I get my escrow?`,
    answer: `When you terminate your contract, everything goes on hold for 45 days for a final audit.`,
  },
  { question: `When is the pay period?`, answer: `(Sunday-Saturday)` },
  {
    question: `Why does the amount on my settlement statements keep changing while I am in the middle of the term audit?`,
    answer: `During the audit process the balance forward may change do to Repair orders, unpaid loads, or fuel used while contracted.`,
  },
  {
    question: `How much do I get paid a mile, and how to find it?`,
    answer: `Please refer to Appendix 3 of your hauling agreement.`,
  },
  {
    question: `How do I get money out of escrow?`,
    answer: `Escrow is mostly used for maintenance repairs or lease payments.`,
  },
  {
    question: `Do I not get paid empty miles?`,
    answer: `Please refer to Appendix 3 of your hauling agreement.`,
  },
  {
    question: `How to set up their direct deposit?`,
    answer: `Please send an email to your driver agent with your bank account information, we will need a picture of an account, blank check, misc for verification.`,
  },
];

function FaqItem({
  question,
  answer,
  index,
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`payroll-faq-item${open ? ' is-open' : ''}`}
      style={{ ['--payroll-faq-delay' as string]: `${0.3 + index * 0.04}s` }}
    >
      <button
        type="button"
        className="payroll-faq-item__header"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span className="payroll-faq-item__question">{question}</span>
        <span className={`payroll-faq-item__chevron${open ? ' is-open' : ''}`} aria-hidden="true">
          <ChevronRight color="oklch(0.55 0.01 260)" />
        </span>
      </button>
      {open ? (
        <div className="payroll-faq-item__answer">
          <Markup content={answer} />
        </div>
      ) : null}
    </div>
  );
}

const PayrollFAQ: React.FC = () => {
    useLogPageVisit('LP Payroll FAQ', 'User viewed the Payroll FAQ page');
  const history = useHistory();
  const { onSheet, onIonScroll } = useTransparentHeaderContrast();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      setTimeout(() => setMounted(true), 30);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  const goBack = () => {
    if (history.length > 1) history.goBack();
    else history.replace('/Money');
  };

  return (
    <FAQFirstIn>
      <IonPage>
        <LoadDetailHeader title="Settlement F.A.Q." onBack={goBack} onSheet={onSheet} />

        <IonContent
          fullscreen
          className="design-a-content design-a-content--light"
          scrollEvents={true}
          onIonScroll={onIonScroll}
        >
          <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
            <div className="home-hero advance-hero">
              <div className="advance-hero__eyebrow">Settlements</div>
              <div className="advance-hero__title home-display">Settlement F.A.Q.</div>
              <div className="advance-hero__meta">{questionsAndAnswers.length} common questions</div>
            </div>

            <div className="home-sheet payroll-sheet" id="payroll-faq">
              <section className="safety-section">
                <h2 className="safety-section__title home-section-label">Frequently asked</h2>
                <div className="payroll-faq-list">
                  {questionsAndAnswers.map((item, index) => (
                    <FaqItem key={item.question} question={item.question} answer={item.answer} index={index} />
                  ))}
                </div>
              </section>
            </div>
          </div>
        </IonContent>
      </IonPage>
    </FAQFirstIn>
  );
};

export default PayrollFAQ;
